module.exports = __webpack_public_path__ + "2a47a29ceb33c966c8d79f8d5a5ea448.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-Light.ttf
// module id = 1248
// module chunks = 0